import { memo, useMemo, useState, ChangeEventHandler } from 'react';
import { Input } from 'antd';
import AnimationContainer from '@/components/animation-container';
import { ModalCloseSvg } from '@/components/svg-icons/common';
import { getQaStore } from '@/store/qa';
import classNames from 'classnames';
import './index.scss';

interface IProps {
    visible: boolean;
    onClose: () => void;
    onSumbit: (params: { labels: number[]; content: string }) => void;
}

const FeedbackModal = ({ visible, onClose, onSumbit }: IProps) => {
    const [labels, setLabels] = useState<number[]>([]);
    const [content, setContent] = useState('');

    const types = useMemo(() => {
        const list = getQaStore()?.qaConfig?.feedbackLabelList || [];
        return list.map(item => ({
            ...item,
            checkouted: labels.includes(item.id),
        }));
    }, [visible, labels]);

    const disabled = useMemo(() => {
        if (content || labels.length) return false;
        return true;
    }, [labels, content]);

    const handleCheckout = (id: number) => {
        if (labels.includes(id)) {
            setLabels(labels.filter(item => item !== id));
        } else {
            setLabels(labels.concat([id]));
        }
    };

    const handleChange: ChangeEventHandler<HTMLTextAreaElement> = ev => setContent(ev.target.value);

    const handleSumbit = () => {
        if (disabled) return;
        onSumbit({ labels, content });
        handleClose();
    };

    const handleClose = () => {
        onClose();
        handleReset();
    };

    const handleReset = () => {
        setContent('');
        setLabels([]);
    };

    return visible ? (
        <div className="feedback-modal-overlay">
            <AnimationContainer type="from_small_to_big">
                <div className="feedback-modal">
                    <div className="feedback-modal__title">反馈与建议</div>
                    <ModalCloseSvg className="feedback-modal__close" onClick={handleClose} />
                    {types.map(item => {
                        return (
                            <div key={item.id} className="feedback-modal__type" onClick={() => handleCheckout(item.id)}>
                                <div
                                    className={classNames('feedback-modal__checkout', item.checkouted && 'feedback-modal__checkouted')}
                                ></div>
                                <span>{item.feedbackLabel}</span>
                            </div>
                        );
                    })}
                    <Input.TextArea
                        className="feedback-modal__textarea"
                        autoSize={{ maxRows: 4, minRows: 4 }}
                        placeholder="描述具体原因，您的反馈会帮助我们做得更好～"
                        onChange={handleChange}
                        value={content}
                        maxLength={500}
                        showCount
                    />
                    <div
                        className={classNames('feedback-modal__sumbit', disabled && 'feedback-modal__sumbit--disabled')}
                        onClick={handleSumbit}
                    >
                        提交
                    </div>
                </div>
            </AnimationContainer>
        </div>
    ) : null;
};

export default memo(FeedbackModal);
